module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recipients":"Patients","recipient_offers":"Offers"},"fr":{"recipients":"Patients","recipient_offers":"Offers"}}')
  delete Component.options._Ctor
}
